import {
  Box,
  mdBumps,
  Section,
  SectionContent,
  SectionDescription,
  SectionProps,
  SectionTitle,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CoverOption, Quote } from '../../../domain'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { getCoreAssetType } from '../../../state/configuration'
import { useProduct } from '../../product/productContext'
import { CoverEndorsements } from './CoverEndorsements'
import { IncludedCoverItems } from './IncludedCoverItems'
import { IncludedCoverItemsWithInfo } from './IncludedCoverItemsWithInfo'
import { OptionalCoverItems } from './OptionalCoverItems'

export interface CoverSectionProps extends SectionProps {
  quote: Quote
  onChange?: (cover: CoverOption) => void
}

const tKey = TKey('components.cover-section')

export const CoverSection: FunctionComponent<CoverSectionProps> = ({
  quote,
  onChange,
  ...props
}) => {
  const { t } = useWriskTranslation()
  const { product } = useProduct()
  const { covers } = getCoreAssetType(product)

  const includedCoverItems = covers.withInfo ? (
    <IncludedCoverItemsWithInfo includedCovers={covers.included} />
  ) : (
    <IncludedCoverItems quote={quote} />
  )

  const subheader = t(tKey('subheader'), { defaultValue: null })

  return (
    <Section width={1} {...props}>
      <SectionTitle>{t(tKey('header'))}</SectionTitle>
      {subheader && <SectionDescription>{subheader}</SectionDescription>}
      <SectionContent>
        <Box width={1} variant='raised'>
          {includedCoverItems}
          <OptionalCoverItems quote={quote} onChange={onChange} />
        </Box>
      </SectionContent>
      <CoverEndorsements quote={quote} mt={mdBumps} />
    </Section>
  )
}
